import React from 'react';
import styles from '../GameDetailsTop.module.scss';
import { GameTileProps } from '../../../modular-grid/types';
import { isEqual } from 'src/utils/lodash-alternatives';
import { GameDetailsTopMessages } from '../GameDetailsTop';
import { AccountLi } from '../../../../components/icons';
import { mapTable } from '../../../../model/algolia/utils';

interface GameDetailsTopInfoTablePropTypes {
  game: GameTileProps;
  staticTexts: GameDetailsTopMessages;
}

const GameDetailsTopInfoTable: React.FC<GameDetailsTopInfoTablePropTypes> = React.memo(
  ({ game, staticTexts }) => {
    if (!game.table) return null;
    const { stake, playersInfo } = mapTable(game.table)!;
    const layerInfoText = stake ? `${playersInfo}, ${stake}` : playersInfo;
    return (
      <div
        data-testid="game-details-header-game-table-info"
        className={styles.gameTableInfo}
      >
        <span>{staticTexts.tableInfo}: </span>
        <AccountLi className={styles.tableIcon} />
        <span className={styles.tableInfo}>{layerInfoText}</span>
      </div>
    );
  },
  (
    prevProps: GameDetailsTopInfoTablePropTypes,
    nextProps: GameDetailsTopInfoTablePropTypes
  ) => isEqual(prevProps, nextProps)
);

export default GameDetailsTopInfoTable;
